import { render, staticRenderFns } from "./TPhoneInput.vue?vue&type=template&id=2bc73739&scoped=true"
import script from "./TPhoneInput.vue?vue&type=script&setup=true&lang=js"
export * from "./TPhoneInput.vue?vue&type=script&setup=true&lang=js"
import style0 from "./TPhoneInput.vue?vue&type=style&index=0&id=2bc73739&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc73739",
  null
  
)

export default component.exports